<template>
  <v-card :disabled="loading" outlined style="min-height: 400px; ;">
    <v-progress-linear v-show="loading" color="primary" indeterminate></v-progress-linear>
    <v-card-title> Avanco Físico </v-card-title>
    <v-card-text v-if="!noData">
      <div style="">
        <line-chart :chart-data="chartData" :options="chartOptions" />
      </div>
    </v-card-text>
    <v-card-text v-else>

       <div class="text-center text-h5 mt-10 ">
        <v-icon size="64" color="grey">mdi-chart-box-outline</v-icon>
        <div class="mt-4">Nenhum dado encontrado para o gráfico de avanço físico.</div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { Line } from "vue-chartjs";
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);
import { mapActions } from "vuex";
export default {
  components: { "line-chart": Line },
  data() {
    return {
      noData: false,
      costId: null,
      loading: false,
      chartData: {
        labels: [],
        datasets: [
          {
            label: "Avanço Físico",
            backgroundColor: "#1976d2",
            borderColor: "#1976d2",
            fill: false,
            data: [],
            order: 1,
          },
          {
            label: "Avanço Financeiro",
            backgroundColor: "#4caf50",
            borderColor: "#4caf50",
            fill: false,
            data: [],
            order: 2,
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions("Dashboard", ["getPhysicalProgress"]),
    getData() {
      this.loading = true;
      this.getPhysicalProgress()
        .then((response) => {
          this.chartData.datasets[0].data = response.data.physical_progress;
          this.chartData.datasets[1].data = response.data.financial_progress;
          this.chartData.labels = response.data.dates;
          this.costId = response.data.cost_id;
        })
        .catch((error) => {
          if (error.response.status === 423) {
            this.noData = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showReporAbc() {
      this.$router.push({ path: "/system/report/input/abc/inputs/" + this.costId });
    },
  },
};
</script>
